var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentImage',{attrs:{"id":_vm.author.image.id,"cropper-data":_vm.cropperData}})}
var staticRenderFns = []

export { render, staticRenderFns }